var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningStop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#warning-stop_svg__clip0_457_5791)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.737.293A1 1 0 017.444 0h9.112a1 1 0 01.707.293l6.444 6.444a1 1 0 01.293.707v9.112a1 1 0 01-.293.707l-6.444 6.444a1 1 0 01-.707.293H7.444a1 1 0 01-.707-.293L.293 17.263A1 1 0 010 16.556V7.444a1 1 0 01.293-.707L6.737.293zM7.858 2L2 7.858v8.284L7.858 22h8.284L22 16.142V7.858L16.142 2H7.858z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 6a1 1 0 011 1v6a1 1 0 11-2 0V7a1 1 0 011-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 18a1 1 0 100-2 1 1 0 000 2z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "warning-stop_svg__clip0_457_5791"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgWarningStop;